import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DSButton, DSIcon } from '../design-system/primitives';
import './AccessDenied.css';

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Try to go back, or go to account page if no history
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/my-membership');
    }
  };

  return (
    <div className="access-denied-page">
      <div className="access-denied-content">
        <div className="access-denied-icon"><DSIcon name="block" /></div>
        <h1>Access Denied</h1>
        <p>You don't have permission to view this page.</p>
        <p className="access-denied-hint">
          If you believe this is an error, please contact an administrator.
        </p>
        <div className="access-denied-actions">
          <DSButton appearance="solid" tone="primary" onClick={handleGoBack}>
            Go Back
          </DSButton>
          <DSButton appearance="outline" tone="secondary" onClick={() => navigate('/my-membership')}>
            Go to My Account
          </DSButton>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
